import { render, staticRenderFns } from "./view-custom-field.vue?vue&type=template&id=72571fea"
import script from "./view-custom-field.vue?vue&type=script&lang=js"
export * from "./view-custom-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72571fea')) {
      api.createRecord('72571fea', component.options)
    } else {
      api.reload('72571fea', component.options)
    }
    module.hot.accept("./view-custom-field.vue?vue&type=template&id=72571fea", function () {
      api.rerender('72571fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/view-custom-field.vue"
export default component.exports